import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface OperationsKeyType {
  activityDate: LocalesKey;
  addRecord: LocalesKey;
  addRecords: LocalesKey;
  addRecordAndBlock: LocalesKey;
  addRecordAndVoid: LocalesKey;
  record: LocalesKey;
  recordAbout: LocalesKey;
  recordAdded: LocalesKey;
  records: LocalesKey;
  recordUpdated: LocalesKey;
  reasons: LocalesKey;
  status: LocalesKey;
  recorded: LocalesKey;
  recordedDate: LocalesKey;
  dueDate: LocalesKey;
  duty: LocalesKey;
  completed: LocalesKey;
  completedDate: LocalesKey;
  createCompanyRecord: LocalesKey;
  clientStatus: LocalesKey;
  description: LocalesKey;
  lastRecord: LocalesKey;
  leaveOfAbsence: LocalesKey;
  subject: LocalesKey;
  statuses: {
    planned: LocalesKey;
    completed: LocalesKey;
    not_started: LocalesKey;
    in_progress: LocalesKey;
    canceled: LocalesKey;
    waiting_for_input: LocalesKey;
    deferred: LocalesKey;
  };
  tat: LocalesKey;
  types: {
    call: LocalesKey;
    event: LocalesKey;
    task: LocalesKey;
    clientStatus: LocalesKey;
  };
  typeOfActivity: LocalesKey;
  messages: {
    addConfirm: {
      areYouSureYouWantToAdd: LocalesKey;
      record: LocalesKey;
    };
  };
  noTat: LocalesKey;
  notified: LocalesKey;
  updateRecord: LocalesKey;
  warning: LocalesKey;
}

export const operationsKeys = keyPathMirror<OperationsKeyType, string>(
  {
    activityDate: null,
    addRecord: null,
    addRecords: null,
    addRecordAndBlock: null,
    addRecordAndVoid: null,
    record: null,
    recordAbout: null,
    recordAdded: null,
    records: null,
    recordUpdated: null,
    reasons: null,
    status: null,
    recorded: null,
    recordedDate: null,
    dueDate: null,
    duty: null,
    completed: null,
    completedDate: null,
    createCompanyRecord: null,
    clientStatus: null,
    description: null,
    lastRecord: null,
    leaveOfAbsence: null,
    subject: null,
    statuses: {
      planned: null,
      completed: null,
      not_started: null,
      in_progress: null,
      canceled: null,
      waiting_for_input: null,
      deferred: null
    },
    tat: null,
    types: {
      call: null,
      event: null,
      task: null,
      clientStatus: null
    },
    typeOfActivity: null,
    messages: {
      addConfirm: {
        areYouSureYouWantToAdd: null,
        record: null
      }
    },
    noTat: null,
    notified: null,
    updateRecord: null,
    warning: null
  },
  'models.operations.'
);
